module.exports = __webpack_public_path__ + "static/img/download_content1.753241b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download_content1.png
// module id = 6jcE
// module chunks = 1